(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bn.js"));
	else if(typeof define === 'function' && define.amd)
		define("Ganache-Cli", ["bn.js"], factory);
	else if(typeof exports === 'object')
		exports["Ganache-Cli"] = factory(require("bn.js"));
	else
		root["Ganache-Cli"] = factory(root["bn.js"]);
})(global, function(__WEBPACK_EXTERNAL_MODULE__6__) {
return 